console.log('%chome.js', 'color: yellow');
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import * as Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import {createPinia} from 'pinia';

import DMortgageForm from '@components/molecules/DMortgageForm.vue';
import DInvestForm from '@components/molecules/DInvestForm.vue';
import DMortgageInfo from '@components/molecules/DMortgageInfo.vue';
import DIndexFilter from '@components/organisms/DIndexFilter.vue';
import DMap from '@components/organisms/DMap.vue';

const pinia = createPinia();
$(window).on('load', function(e) {
    try {
        Vue.createApp({components: {DMap}}).use(VueAxios, axios).mount('.d-index-geography__map');
        Vue.createApp({components: {DIndexFilter}}).use(VueAxios, axios).use(pinia).mount('.d-index-flats');
        Vue.createApp({components: {DMortgageForm}}).use(VueAxios, axios).mount('#mortgage-form');
        Vue.createApp({components: {DInvestForm}}).use(VueAxios, axios).mount('.d-invest__calc');
    } catch (e) {
        console.error(e);
    }

});

const progressBar = document.querySelector('.d-top-slider__timer');

new Swiper('[data-top-slider]', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    autoplay: {
        delay: 3500,
        //disableOnInteraction: false
    },
    pagination: {
        el: '[data-top-slider-pagination]',
        type: 'custom',
        renderCustom: function(swiper, current, total) {
            let currentSlide = current.toString();
            let totalSlide = total.toString();
            return `<span>${ currentSlide }&nbsp;-&nbsp;${ totalSlide }</span>`;
        },
    },
    navigation: {
        nextEl: '.topSlider._next',
        prevEl: '.topSlider._prev',
    },
    on: {
        init: function() {
            progressBar.classList.remove('active');
            progressBar.classList.add('animate');
            progressBar.classList.add('active');
        },
        slideChangeTransitionStart: function(swiper) {
            progressBar.classList.remove('animate');
            progressBar.classList.remove('active');
            if (!swiper.autoplay.running) return;
            progressBar.classList.add('active');
        },
        slideChangeTransitionEnd: function(swiper) {
            if (!swiper.autoplay.running) return;
            progressBar.classList.add('animate');
        },
        slideChange: function(swiper) {
            progressBar.classList.remove('animate');
            progressBar.classList.remove('active');
            if (!swiper.autoplay.running) return;
            progressBar.classList.add('animate');
            progressBar.classList.add('active');
        },
        autoplayStop: function() {
            progressBar.classList.remove('animate');
            progressBar.classList.remove('active');
            progressBar.setAttribute('hidden', true);
        },
    },
});
const $utpSliderWrap = $('.d-index-utp');
const $utpSlider = $('[data-index-utp-slider]');
const $utpSlides = $utpSlider && $utpSlider.length ? $utpSlider.find('.d-index-utp-slide') : [];
const utpSlidesCount = $utpSlides.length;
if ($utpSlider && $utpSlider.length) {
    if (utpSlidesCount > 2) {
        $utpSlider.addClass('_loop');
        $utpSliderWrap.addClass('_loop');

    }
    else {
        $utpSlider.removeClass('_loop');
        $utpSliderWrap.removeClass('_loop');
    }

    //console.log('$utpSlides', $utpSlides.length)
    new Swiper($utpSlider[0], {
        loop: utpSlidesCount > 2,
        slidesPerView: 'auto',
        spaceBetween: 24,
        navigation: {
            nextEl: '[data-index-utp-slider-next]',
            prevEl: '[data-index-utp-slider-prev]',
        },
        breakpoints: {
            320: {
                slidesPerView: 'auto',
                spaceBetween: 12,
                loop: true,
            },
            768: {
                slidesPerView: 'auto',
                spaceBetween: 24,
                loop: true,
            },
            1024: {
                slidesPerView: 'auto',
                loop: utpSlidesCount > 2,
            },
            1280: {
                slidesPerView: 2,
                //slidesPerView: utpSlidesCount > 2 ? 3 : 2,
                spaceBetween: 24,
            },
            1600: {
                slidesPerView: 2,
                //slidesPerView: utpSlidesCount > 2 ? 3 : 2,
                spaceBetween: 24,
            },
            1920: {
                slidesPerView: utpSlidesCount > 2 ? 3 : 2,
                spaceBetween: 24,
            },
        },
    });

}

new Swiper('[data-news-preview-slider]', {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 32,
    navigation: {
        nextEl: '.newsPreviewSlider._next',
        prevEl: '.newsPreviewSlider._prev',
    },
    breakpoints: {
        320: {
            slidesPerView: 'auto',
            spaceBetween: 12,
        },
        768: {
            slidesPerView: 'auto',
            spaceBetween: 32,
        },
        1280: {
            slidesPerView: 3,
        },
    },
});

const $body = $('body');
const $header = $('[data-header]');
const $geoMap = $('[data-geography]');

$body.on('click', '[data-geography-show]', function(e) {
    e.preventDefault();
    $geoMap.addClass('_show');
    $header.addClass('_hide');
    $body.addClass('_popupOpen');
    document.body.style.overflow = 'hidden';
});
$body.on('click', '[data-geography-close]', function(e) {
    e.preventDefault();
    $geoMap.removeClass('_show');
    $header.removeClass('_hide');
    $body.removeClass('_popupOpen');
    document.body.style.overflow = 'initial';
});

$body.on('click', '[data-map-point]', function(e) {
    e.preventDefault();
    if (window.matchMedia('(max-width: 1279px)').matches) { //window.matchMedia('(hover: hover) and (pointer: fine)')
        $(this).addClass('_active');
        $('[data-map-point-info]').addClass('_show');
    }
});
$body.on('click', '[data-map-point-info-close]', function(e) {
    e.preventDefault();
    $('[data-map-point]').removeClass('_active');
    $('[data-map-point-info]').removeClass('_show');
});

document.addEventListener('mortgageInfo', () => {
    document.querySelector('.d-purchase-mortgage__content').classList.add('_info');
    document.querySelector('.d-purchase-mortgage__content').innerHTML = '';
    const app = Vue.createApp(DMortgageInfo);
    app.mount('.d-purchase-mortgage__content');
});
